/**
 * Character roster — all catalog entries from public/characters/index.json.
 */

const INDEX_URL = `/characters/index.json`;
const STORAGE_KEY = `afters.character`;

/** @type {null | Promise<RosterEntry[]>} */
let cache = null;

/**
 * @typedef {{ name: string, sex: string, verts?: number, tris?: number }} RosterEntry
 */

/** Derive a human-readable name from asset id (e.g. Character_17_Police → 17 Police). */
export function displayName(id) {
  return String(id || "")
    .replace(/^Character_/, "")
    .replace(/_/g, " ")
    .trim() || id;
}

export function thumbUrl(name) {
  return `/characters/${name}.png`;
}

export function getSavedCharacter() {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function saveCharacter(name) {
  try {
    if (name) localStorage.setItem(STORAGE_KEY, name);
  } catch {
    /* ignore */
  }
}

/** @returns {Promise<RosterEntry[]>} */
export function loadRoster() {
  if (!cache) {
    cache = fetch(INDEX_URL)
      .then((r) => r.json())
      .then((data) => (data.characters || []).map((c) => ({ ...c })));
  }
  return cache;
}
